function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import collateNotifications from './collateNotifications';
import Stack from './Stack';
import Notification from './Notification';

var NotificationLayer = /*#__PURE__*/function (_PureComponent) {
  _inherits(NotificationLayer, _PureComponent);

  var _super = _createSuper(NotificationLayer);

  function NotificationLayer() {
    var _this;

    _classCallCheck(this, NotificationLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      items: []
    });

    return _this;
  }

  _createClass(NotificationLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var layer = this.props.layer;
      this.setState({
        items: layer.getAll()
      });
      layer.on('update', function (_ref) {
        var items = _ref.items;
        return _this2.setState({
          items: items
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var layer = this.props.layer;
      layer.off();
    }
  }, {
    key: "render",
    value: function render() {
      var items = this.state.items;
      var _this$props = this.props,
          layer = _this$props.layer,
          qa = _this$props.qa;
      var collatedItems = collateNotifications(items);

      var renderItem = function renderItem(itemId) {
        var x = collatedItems.items[itemId];
        return /*#__PURE__*/React.createElement(Notification, _extends({
          key: x.id
        }, x, {
          onClose: x.close || x.onClose,
          qa: "".concat(qa, "#").concat(x.id)
        }));
      };

      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: "full-screen",
        style: {
          zIndex: layer.elevation
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 400
        },
        className: "psw-m-m psw-top-right psw-notification-group"
      }, collatedItems.order.map(function (item) {
        if (item.type === 'stack') {
          var stack = collatedItems.stacks[item.id];
          return /*#__PURE__*/React.createElement(Stack, null, stack.map(function (itemId) {
            return renderItem(itemId);
          }));
        }

        return renderItem(item.id);
      })));
    }
  }]);

  return NotificationLayer;
}(PureComponent);

NotificationLayer.defaultProps = {
  qa: '',
  className: '',
  format: function format() {}
};
NotificationLayer.propTypes = {
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Function to localize text before render
   * See `@sie/web-common-i18n` for more information on the
   * expected interface
   */
  format: PropTypes.func,

  /**
   * Get a Component to render
   */
  getComponent: PropTypes.func.isRequired,

  /**
   * Layer instance as defined in `@sie/web-common-layers`
   */
  layer: PropTypes.shape({
    /**
     * The elevation of the rendered layer item (managed by `@sie/web-common-layers`)
     */
    elevation: PropTypes.number,

    /**
     * Removes all event callbacks for the layer
     */
    off: PropTypes.func,

    /**
     * Adds an event callback to be called when events occur on the layer
     */
    on: PropTypes.func,

    /**
     * Gets all layer items on a layer
     */
    getAll: PropTypes.func
  }).isRequired
};
export default NotificationLayer;